import { Icon } from 'vopay';

export default function Throbber() {
  return <Icon icon="loader" size="xl-jumbo" color="primary-dark-transparent" />;
}
